<template>
    <div style="display: flex; flex-direction: column">
    <div class="query-bar">
        <el-input v-model="fName" placeholder="产品名称" size="small" style="width:200px;"></el-input>
        <el-input v-model="fName" placeholder="产品编号" size="small" style="width:200px;"></el-input>
        <el-button type="primary" size="small" @click="refresh">查询</el-button>
        <el-button type="primary" size="small" @click="_modify(null)" v-if="canAdd">新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table v-loading="loading" v-el-table-height-fix :data="tableData" height="100%">
        <el-table-column prop="fName" label="产品编号"> </el-table-column>
        <el-table-column prop="fNumber" label="产品名称"> </el-table-column>
        <el-table-column prop="fDes" label="规格"> </el-table-column>
        <el-table-column prop="fDes" label="单位"> </el-table-column>
        <el-table-column prop="fDes" label="仓库"> </el-table-column>
        <el-table-column prop="fDes" label="期初数"> </el-table-column>
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
              <template>
                <el-button @click="_modify(scope.row)" type="text" size="small">修改</el-button>
              </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            fName:null,
            tableData:[],
        }
    }
}
</script>
<style lang="">
    
</style>